"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAmountFieldProfileQueuedMutation = updateAmountFieldProfileQueuedMutation;
exports.setActiveAmountFieldProfileQueuedMutation = setActiveAmountFieldProfileQueuedMutation;
exports.saveAmountFieldFormatQueuedMutation = saveAmountFieldFormatQueuedMutation;
exports.deleteAmountFieldFormatQueuedMutation = deleteAmountFieldFormatQueuedMutation;
const GQLCachePatch = __importStar(require("gql-cache-patch"));
const GraphQLMutations = __importStar(require("../graphql-mutations"));
function updateAmountFieldProfileQueuedMutation(id, name, measureSystem) {
    const mutation = {
        document: GraphQLMutations.setAmountProfileMutation,
        variables: {
            amountProfile: {
                id,
                measureSystem,
                name
            }
        },
        optimisticCachePatches: updateAmountFieldProfileCachePatches(id, name, measureSystem)
    };
    return mutation;
}
function setActiveAmountFieldProfileQueuedMutation(profileId, userProfileId) {
    const settingsKey = `UserSettingsType;userSettings-${userProfileId}`;
    const profileCacheKey = `AmountFieldProfileType;${profileId}`;
    const mutation = {
        document: GraphQLMutations.setActiveAmountProfileMutation,
        variables: {
            amountProfileId: profileId
        },
        optimisticCachePatches: [
            GQLCachePatch.updateField(settingsKey, "selectedAmountFieldProfile", profileCacheKey)
        ]
    };
    return mutation;
}
function saveAmountFieldFormatQueuedMutation(amountFieldProfileId, measureSystem, fieldGroup, fieldName, decimalCount, unit) {
    const mutation = {
        document: GraphQLMutations.saveAmountFieldFormatMutation,
        variables: {
            amountFieldFormat: {
                amountFieldProfileId,
                decimalCount,
                fieldGroup,
                fieldName,
                unit
            }
        },
        optimisticCachePatches: saveAmountFormatOptimisticCachePatches(amountFieldProfileId, measureSystem, fieldGroup, fieldName, decimalCount, unit)
    };
    return mutation;
}
function deleteAmountFieldFormatQueuedMutation(amountFieldProfileId, fieldGroup, fieldName) {
    const mutation = {
        document: GraphQLMutations.deleteAmountFieldFormatMutation,
        variables: {
            amountFieldFormat: {
                amountFieldProfileId,
                fieldGroup,
                fieldName
            }
        },
        optimisticCachePatches: deleteAmountFormatOptimisticCachePatches(amountFieldProfileId, fieldGroup, fieldName)
    };
    return mutation;
}
function deleteAmountFormatOptimisticCachePatches(amountFieldProfileId, fieldGroup, fieldName) {
    const profileCacheKey = `AmountFieldProfileType;${amountFieldProfileId}`;
    const formatCacheKey = `AmountFieldFormatType;${amountFieldProfileId};${fieldGroup};${fieldName}`;
    return [
        GQLCachePatch.removeEntityElement(profileCacheKey, "amountFieldFormats", formatCacheKey),
        GQLCachePatch.deleteEntity(formatCacheKey)
    ];
}
function saveAmountFormatOptimisticCachePatches(amountFieldProfileId, measureSystem, fieldGroup, fieldName, decimalCount, unit) {
    const profileCacheKey = `AmountFieldProfileType;${amountFieldProfileId}`;
    const formatCacheKey = `AmountFieldFormatType;${amountFieldProfileId};${fieldGroup};${fieldName}`;
    return [
        GQLCachePatch.createEntity(formatCacheKey, {
            __typename: "AmountFieldFormatType",
            id: formatCacheKey,
            fieldGroup,
            fieldName,
            decimalCount,
            unit,
            measureSystem
        }),
        GQLCachePatch.insertElement(profileCacheKey, "amountFieldFormats", 0, formatCacheKey)
    ];
}
function updateAmountFieldProfileCachePatches(id, name, measureSystem) {
    const profileCacheKey = `AmountFieldProfileType;${id}`;
    return [
        GQLCachePatch.createEntity(profileCacheKey, {
            __typename: "AmountFieldProfileType",
            id,
            name,
            measureSystem,
            isEditable: true,
            amountFieldFormats: []
        })
    ];
}
//# sourceMappingURL=mutations.js.map